<template>
  <v-form @submit.prevent>
      <tiles-form :doc="doc" />
      <v-btn @click="onSubmit">Submit</v-btn>
      <pre>
        {{doc}}
      </pre>
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form"
import router from "@/router";

export default {
  name: "AdminGroupAdd",
  components: {
    TilesForm
  },
  data () {
    return {
      doc: {}
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      let ref = this.$parent.collection.doc();
      ref.set({
        createdOn: new Date(),
        id: ref.id,
        first: this.doc.first,
        last: this.doc.last,
        company: this.doc.company,
        role: this.doc.role,
        bio: this.doc.bio,
        group: this.doc.group,
        initial: this.doc.initial,
      }).then(() => {
        router.push({ name: this.$parent.returnRoute })
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    }
  }
};
</script>
